"use strict";

import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";
import Notification from "./Notification";
import Busy from "../types/busy/Busy.jsx";

export default class DotContainer extends Component {

    static displayName = 'DotContainer';

    static propTypes = {
        legend: PropTypes.content,
        content: PropTypes.content,
        header: PropTypes.content,
        tagline: PropTypes.content,
        position: PropTypes.number,
        count: PropTypes.number,
        style: PropTypes.style,
        buttons: PropTypes.any,
        transitionForward: PropTypes.transition,
        transitionBackward: PropTypes.transition,
        busy: PropTypes.value,
        ErrorNotification: PropTypes.injectClass,
        SuccessNotification: PropTypes.injectClass,
        Busy: PropTypes.injectClass,
        busyMessage: PropTypes.string,
        outerDotClass: PropTypes.string
    };

    static defaultProps = {
        position: 0,
        count: 4,
        transitionForward: "slideRight",
        transitionBackward: "slideLeft",
        ErrorNotification: Notification,
        SuccessNotification: Notification,
        busy: "_internal.busy",
        outerDotClass: ""
    };
    
    static injectedProps = {
        style: "DotContainer",
        ErrorNotification: {
            injectClass: Notification,
            injectProps: {
                message: "global.error"
            }
        },
        SuccessNotification: {
            injectClass: Notification,
            injectProps: {
                message: "global.success"
            }
        },
        Busy
    };

    renderDots() {
        const {position, count, dotClass, doneClass, activeClass} = this.props;
        const ret = [];
        for (let i = 0; i < count; i++) {
            const className = `${dotClass} ${ position === i ? activeClass : ''}`;
            ret.push(<b key={`dot-${i}`} className={className}/>)
        }
        return ret;
    }

    constructor(props, ...args) {
        super(props, ...args);
        this.transition = props.transitionForward;
    }

    componentWillReceiveProps(props) {
        if (props.position != this.props.position) {
            this.transition = (props.position > this.props.position ? props.transitionBackward : props.transitionForward );
            this.forceUpdate();
        }
    }

    render() {

        const {
            children, formClass, busyMessage, buttons, buttonsClass, containerClass, normalSizeContainerClass, innerContainerClass, outerDotClass,
            position, dotsClass, legend, legendClass, header, headerClass, tagline, taglineClass,
            ErrorNotification,
            SuccessNotification,
            Busy
        } = this.props;
        const {Transition, ...transition} = this.transition;

        var normalSizeContainerClassName = this.props.outerDotClass ? this.props.style[this.props.outerDotClass] : "";
        var containerClassName = `${containerClass} ${normalSizeContainerClassName}`;

        //here be dragons.
        return <div className={containerClassName}>
            <ErrorNotification notificationType="error"/>
            <SuccessNotification notificationType="success"/>

            <div className={innerContainerClass}>
                <span className={dotsClass}>
                    {this.renderDots()}
                </span>
                {legend ? <RenderContent content={legend} key="legend" className={legendClass}/> : null }
                {header ? <RenderContent content={header} key="header" className={headerClass} dataType="h2"/> : null}
                {tagline ? <RenderContent content={tagline} key="tagline" className={taglineClass}/> : null}
                <Transition {...transition}>
                    <div className={formClass} key={`dot-transition-${position}`}>
                        {children}
                    </div>
                </Transition>
                <div className={buttonsClass}>
                    {buttons}
                </div>
            </div>
            <Busy message={busyMessage}/>
        </div>
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/DotContainer.jsx
 **/